import React, { useState } from 'react';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import api from '../../../services/api';
import Snackbar from '../../../services/snackbar';

const currentYear = new Date().getFullYear();
const years = Array.from({ length: currentYear - 1950 + 1 }, (_, i) => 1950 + i);
const inputStyles = {
  control: (base) => ({
    ...base,
    width: '300px',
    textAlign: 'left',
  }),
  singleValue: (base) => ({ ...base, textAlign: 'left' }),
  menu: (base) => ({ ...base, textAlign: 'left' }),
  option: (base) => ({ ...base, textAlign: 'left' }),
};

export default function JurisdictionModal({
  onClose, item, jurisdictions,
}) {
  const [jurisdiction, setJurisdiction] = useState(item?.cle_jurisdiction || null);
  const [licenseNumber, setLicenseNumber] = useState(item?.license_number || '');
  const [yearAdmitted, setYearAdmitted] = useState(item?.year_admitted);
  const [complianceGroup, setComplianceGroup] = useState(item?.cle_data?.compliance_group);
  const [deadline, setDeadline] = useState(item?.cle_data?.deadline ? new Date(item.cle_data.deadline) : new Date());

  const updateJurisdiction = async () => {
    await api.account.user.cle_settings.post({
      id: item?.id,
      jurisdiction_id: jurisdiction.id,
      license_number: licenseNumber,
      year_admitted: yearAdmitted,
      compliance_group: complianceGroup,
      deadline: deadline.toISOString(),
    }).then(() => {
      Snackbar.show(`Jurisdiction ${jurisdiction.name} ${item ? 'updated' : 'created'}.`);
      window.location.href = '/account/edit?tab=cle';
    }).catch(() => Snackbar.show(`Cant ${item ? 'update' : 'create'} jurisdiction.`));

    onClose();
  };

  return (
    <div className="new-modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <div className="modal-title">
              <img className="react-header-logo" src="/logo_dark.svg" alt="" />
            </div>
          </div>
          <div className="modal-body">
            <div className="account-row">
              <div className="account-field" style={{ justifyContent: 'center', marginTop: '1rem' }}>
                <div className="field-title">Jurisdiction</div>
                <Select
                  placeholder="Select"
                  isSearchable
                  value={{ value: jurisdiction?.id, label: jurisdiction?.name }}
                  onChange={(selected) => setJurisdiction(jurisdictions.find((j) => j.id === selected.value))}
                  options={jurisdictions.map((j) => ({ value: j.id, label: j.name }))}
                  styles={inputStyles}
                />
              </div>
            </div>
            <div className="account-row">
              <div className="account-field" style={{ justifyContent: 'center' }}>
                <div className="field-title">License Number</div>
                <input
                  type="text"
                  value={licenseNumber}
                  onChange={(e) => setLicenseNumber(e.target.value)}
                  id="licenseNumber"
                  className="cle-input"
                />
              </div>
            </div>
            <div className="account-row">
              <div className="account-field" style={{ justifyContent: 'center' }}>
                <div className="field-title">Year Admitted</div>
                <Select
                  placeholder="Select"
                  isSearchable
                  value={{ value: yearAdmitted, label: yearAdmitted }}
                  onChange={(date) => setYearAdmitted(date.value)}
                  options={years.map((year) => ({ value: String(year), label: String(year) })).reverse()}
                  styles={inputStyles}
                />
              </div>
            </div>
            { jurisdiction && jurisdiction?.additional_fields && (
              <>
                { jurisdiction?.compliance_group && jurisdiction?.compliance_group.length > 0 && (
                  <div className="account-row">
                    <div className="account-field" style={{ justifyContent: 'center' }}>
                      <div className="field-title">Compliance Group</div>
                      <Select
                        placeholder="Select"
                        isSearchable={false}
                        value={{ value: complianceGroup, label: complianceGroup }}
                        onChange={(option) => setComplianceGroup(option.value)}
                        options={jurisdiction?.compliance_group.map((g) => ({ value: g, label: g }))}
                        styles={inputStyles}
                      />
                    </div>
                  </div>
                )}
                { jurisdiction?.deadline && (
                  <div className="account-row">
                    <div className="account-field" style={{ justifyContent: 'center' }}>
                      <div className="field-title">Deadline</div>
                      <DatePicker
                        className="search-datepicker cle-input"
                        selected={deadline}
                        onChange={(value) => setDeadline(value)}
                        dateFormat="yyyy-MM-dd"
                      />
                    </div>
                  </div>
                )}
              </>
            )}

            <div className="button-row">
              <div className="modal-button" onClick={updateJurisdiction}>
                {item ? 'Update ' : 'Add '}
                Jurisdiction
              </div>

              <div className="modal-button modal-button-outline" onClick={onClose}>
                Cancel
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
